import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import MessagingScreen from '../screen'
import MessageRoutes from '../../message/routes'

const GoalRoutes = () => {

    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.MESSAGES} component={MessagingScreen} />
            <MessageRoutes />
        </React.Fragment>
    )
}

export default GoalRoutes